export class KeyValueIterator {
    kvs;
    isTruncated;
    currentIndex = -1;
    constructor(kvs, isTruncated) {
        this.kvs = kvs;
        this.isTruncated = isTruncated;
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const lastIndex = this.kvs.length - 1;
        const isDone = lastIndex === this.currentIndex;
        if (!isDone) {
            this.currentIndex += 1;
        }
        const value = this.kvs[this.currentIndex];
        return { done: isDone, value };
    }
}
